document.addEventListener("DOMContentLoaded", () => {
  const shouldNoIndex = /\/products\/.*pr_prod_strat/.test(window.location.href)||
                        /view=/.test(window.location.href)||
                        /limit=/.test(window.location.href);
  if (shouldNoIndex) {
    const metaTag = document.createElement("meta");
    metaTag.name = "robots";
    metaTag.content = "noindex";
    document.head.appendChild(metaTag);
  }
});